import { Filters } from '../../types';

export const REPORT_PAGE_SIZE_KEY = 'report-page-size';

export const DEFAULT_TABLE_FILTERS: Filters = {
    pageNumber: 0,
    pageSize: 10,
    sorted: null,
};
